import { createTheme } from "@mui/material";

export const AiBotDarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#026CCF',
      light: '#026CCF',
      dark: '#026CCF',
    },
    secondary: {
      main: '#b9110c',
      light: '#b9110c',
      dark: '#b9110c',
    },
  },
  components: {
    // Name of the component
    MuiFormControl: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          margin: '0px !important',
        },
      },
    },
  },

  
});
export default AiBotDarkTheme